import { authToken } from './internal.js';
export const getFile = (path, options = {}) => fetch(path, {
    ...options,
    headers: authToken != ''
        ? {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
            'X-Debbie-Auth-Token': authToken,
        }
        : {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
        },
})
    .then(async (res) => {
    if (!res.ok) {
        throw new Error(await res.text());
    }
    return res.blob();
})
    .then((blob) => {
    const file = URL.createObjectURL(blob);
    return file;
});
export const downloadFile = (path, fileName, options = {}) => getFile(path, options).then((file) => {
    const link = document.createElement('a');
    link.download = fileName;
    link.href = file;
    link.style.display = 'hidden';
    document.body.appendChild(link);
    link.click();
    link.remove();
});
//# sourceMappingURL=files.js.map